import React, { useEffect, useState } from "react";
import { FcPaid } from "react-icons/fc";
import FarmerOrderTable from "./Farm Orders/farm_order_table";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import DynamicFilterSelect from "../../../Kryzen Alpha App/Components/layouts/filter.select";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import Pagination from "../../Components/layouts/pagination";
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";
import {setFarmerOrderPage} from "../../redux/Pagination/pagination"

const FarmerOrders = () => {
  const [data, setData] = useState();
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    orderType: "",
    sortByDate: "",
  });
   const dispatch = useDispatch();
    const page = useSelector((state) => state.pagination.farmerOrderPage);
  // const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState(1);
  let role = useSelector((store) => store?.login?.user);
  useEffect(() => {
    if (role && role.Role === process.env.REACT_APP_ROLE_CLIENT) {
      if (role.AdditionalRole !== "farmer partner") {
        navigate("/");
      }
    }
  }, [role]);
  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/pmg/fa-orders/all-fa-orders", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.OrdersCount / 50));
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [page, refresh]);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none m-0">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcPaid className="fs-2  me-1" /> Farmer Orders
                </h2>
                <h4 className="text-muted m-0 p-0">
                  Manage and track your orders.
                </h4>
              </div>
              {/* <div className="col-md-4 d-none d-sm-block">
                <div className="btn-list justify-content-end">
                  <a data-bs-toggle="modal" data-bs-target="#modal-team">
                    <button
                      className="btn"
                      style={{
                        backgroundColor: "rgb(12, 131, 31)",
                        color: "white",
                      }}
                    >
                      <BsJournalArrowUp className="me-2 fs-2" /> Add New Items
                    </button>
                  </a>
                </div>
              </div> */}
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2 mb-3">
                <b className="mt-1">
                  <IoIosArrowRoundDown
                    className="fs-2"
                    style={{ color: "green" }}
                  />{" "}
                  Incoming Order
                </b>
                <b className="mt-0">
                  <IoIosArrowRoundUp
                    className="fs-2"
                    style={{ color: "red" }}
                  />{" "}
                  Outgoing Order
                </b>
              </div>
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Order type:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  orderType: e.target.value,
                                })
                              }
                              value={filters.orderType}
                            >
                              <option value="">Select</option>
                              <option value="incoming">Incoming</option>
                              <option value="outgoing">Outgoing</option>
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Sort by date:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  sortByDate: e.target.value,
                                })
                              }
                              value={filters.sortByDate}
                            >
                              <option value="">Select</option>
                              <option value="new orders">New orders</option>
                              <option value="old orders">Old orders</option>
                            </DynamicFilterSelect>
                          </div>
                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      sortByDate: "",
                                      orderType: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Order type:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                orderType: e.target.value,
                              })
                            }
                            value={filters.orderType}
                          >
                            <option value="">Select</option>
                            <option value="incoming">Incoming</option>
                            <option value="outgoing">Outgoing</option>
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Sort by date:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                sortByDate: e.target.value,
                              })
                            }
                            value={filters.sortByDate}
                          >
                            <option value="">Select</option>
                            <option value="new orders">New orders</option>
                            <option value="old orders">Old orders</option>
                          </DynamicFilterSelect>
                        </div>
                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    sortByDate: "",
                                    orderType: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none d-lg-block d-md-block">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/PESh9WZMiQY"}
                  id={"model-viedo"}
                  name={"farmer orders"}
                ></CustomViedoCard>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <FarmerOrderTable
                  data={data?.OrdersData}
                  currentPage={page}
                  itemsPerPage={50}
                />

                <Pagination
                  page={page}
                  setPage={(newPage) => dispatch(setFarmerOrderPage(newPage))}
                  totalPages={totalPages}
                  pageDatalength={data?.OrdersData?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-block d-lg-none d-md-none ms-2 me-2">
          <CustomViedoCard
            viedoLink={"https://www.youtube.com/embed/PESh9WZMiQY"}
            id={"model-viedo2"}
            name={"farmer orders"}
          ></CustomViedoCard>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FarmerOrders;
